import { BadgeProps as RadixBadgeProps } from '@radix-ui/themes';

import { FlyThemeColor } from '../utils';

type BadgeSize = '1' | '2' | '3';
export type BadgeProps = Omit<RadixBadgeProps, 'color' | 'size' | 'variant'> & {
  size?: BadgeSize;
  color?: FlyThemeColor;
  variant?: BadgeVariant;
  iconStart?: React.ReactNode | string;
  iconEnd?: React.ReactNode | string;
  iconStartSize?: number;
  iconEndSize?: number;
  hoverable?: boolean;
};

export const sizeToClassName: Record<BadgeSize, string> = {
  '1': 'text-size-fly-1 rounded-full h-4.5 px-fly-2 py-[1px]',
  '2': 'text-size-fly-1 rounded-4 h-6',
  '3': 'text-size-fly-2 rounded-full h-7',
};

export type BadgeVariant = RadixBadgeProps['variant'] | 'ghost';

export const variantClassName: Partial<
  Record<NonNullable<BadgeVariant>, string>
> = {
  ghost: 'bg-transparent',
};

export const variantToRadixVariantMap: Record<
  NonNullable<BadgeVariant>,
  RadixBadgeProps['variant']
> = {
  ghost: 'soft',
  outline: 'outline',
  solid: 'solid',
  surface: 'surface',
  soft: 'soft',
};
